module.exports = __webpack_public_path__ + "img/viewPointMapIcon.dbb81e30.png";